import { Icon, SliderModal, Steps, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { Pressable, Skeleton } from 'native-base';
import React, { useCallback, useEffect, useState } from 'react';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../../../../../routes/types';
import { useConsortiumActions } from '../../../../../../../../store/consortium/actions';
import { Header } from '../../../../../Header';

import { ListPlans } from './components/ListPlans';
import { data } from './data';

interface PlansProps {}

export const Plans: React.FC<PlansProps> = () => {
  const sliderModalWidth = useBreakpointValue({ base: 1, lg: 0.45 });
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'ConsortiumPlans'>>();
  const { handleSelectCustomerConsortiumPlan } = useConsortiumActions();
  const [isLoading, setIsLoading] = useState(true);
  const headerTitle = 'Simulador de consórcio';

  const { canGoBack, goBack, navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = useCallback(() => {
    if (canGoBack()) {
      goBack();
    }
  }, [canGoBack, goBack]);

  const handleSelectPlan = useCallback(
    (item: (typeof data)[number]) => {
      handleSelectCustomerConsortiumPlan({ ...item, ...params });
      navigate('Consortium');
    },
    [handleSelectCustomerConsortiumPlan, params, navigate]
  );

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <SliderModal
      dismissWhenClickOutside
      onDismiss={handleGoBack}
      width={sliderModalWidth}
      modalInsideModal>
      <VStack
        p={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'] }}
        space={Spacing['inline.xxxs']}>
        <HStack alignItems="center" justifyContent="space-between">
          {isDesktop ? (
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Pressable onPress={handleGoBack}>
                <Icon
                  testID="input-clear-icon"
                  name="ArrowLeft"
                  size="xxs"
                  color={Color['neutral.black']}
                  borderColor={Color['neutral.black']}
                />
              </Pressable>
              <Text variant="semibold" fontSize={Typography['fontsize.lg']} color="neutral.black">
                {headerTitle}
              </Text>
            </HStack>
          ) : (
            <Header title={headerTitle} onPress={handleGoBack} />
          )}
          {!isMobile && <Steps testId="qa" currentStep={2} totalSteps={2} />}
        </HStack>
        {isMobile && <Steps testId="qa" currentStep={2} totalSteps={2} />}
        <VStack space={Spacing['stack.nano']}>
          {isLoading ? (
            <Skeleton
              w="45%"
              h={Typography['fontsize.xl']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          ) : (
            <Text variant="semibold" fontSize={Typography['fontsize.xl']} color="neutral.black">
              Encontramos {data.length} plano(s).
            </Text>
          )}
          {isLoading ? (
            <Skeleton
              w="35%"
              h={Typography['fontsize.md']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          ) : (
            <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.medium">
              Selecione uma das opções
            </Text>
          )}
        </VStack>
        <ListPlans params={params} onPress={handleSelectPlan} isLoading={isLoading} />
      </VStack>
    </SliderModal>
  );
};
